import { createContext } from 'react';

export type WebhookCtx = {
  showTestSuccessAlert: boolean;
  showTestErrorAlert: boolean;
  TestError: string;
  showDeactivateSuccessAlert: boolean;
  showDeactivateErrorAlert: boolean;
  DeactivateError: string;
};

const WebhookContext = createContext<WebhookCtx>({
  showTestSuccessAlert: false,
  showTestErrorAlert: false,
  TestError: '',
  showDeactivateSuccessAlert: false,
  showDeactivateErrorAlert: false,
  DeactivateError: '',
});

export default WebhookContext;
